import { RacemapColors } from '@racemap/utilities/consts/common';
import { type ThemeConfig, theme } from 'antd';

const { getDesignToken } = theme;

export const themeConfig: ThemeConfig = {
  token: {
    colorPrimary: RacemapColors.PaleBlue,
    borderRadius: 3.5,
    colorBorder: RacemapColors.Gray,
    colorLink: RacemapColors.PaleBlue,
  },
  components: {
    Form: {
      labelColor: '#212529',
    },
    Table: {
      borderColor: RacemapColors.Gray,
      rowSelectedBg: RacemapColors.LightBlue,
    },
    Card: {
      colorBorderSecondary: RacemapColors.Gray,
    },
    Button: {
      colorLink: RacemapColors.PaleBlue,
      defaultColor: RacemapColors.PaleBlue,
    },
    Layout: {
      bodyBg: 'transparent',
      siderBg: 'transparent',
    },
  },
};

// static theme to use outside of react lifecycle
export const staticThemeToken = getDesignToken(themeConfig);
